import { apiOpcs } from 'yxt-biz-pc/packages/api';
export const getAreaCodeList = () => {
  return apiOpcs.get('sms/list');
};
